import moment from 'moment'

export const thead_fn = () => {
  return [
    {
      label: "日付",
      prop: "date",
      width: 178,
      isInput: false,
    },
    {
      label: "目標（チケット）",
      prop: "goalTicket",
      width: 214,
      isInput: true,
    },
    {
      label: "実績（チケット）",
      prop: "actualTicket",
      width: 224,
      isInput: false,
    },
    {
      label: "達成率(%)",
      prop: "ticketRate",
      width: 158,
      isInput: false,
    },
    {
      label: "目標（コンセ）",
      prop: "goalConcession",
      width: 214,
      isInput: true,
    },
    {
      label: "実績（コンセ）",
      prop: "actualConcession",
      width: 224,
      isInput: false,
    },
    {
      label: "達成率(%)",
      prop: "concessionRate",
      width: 158,
      isInput: false,
    },
    {
      label: "目標（物販）",
      prop: "goalCommercial",
      width: 214,
      isInput: true,
    },
    {
      label: "実績（物販）",
      prop: "actualCommercial",
      width: 224,
      isInput: false,
    },
    {
      label: "達成率(%)",
      prop: "commercialRate",
      width: 158,
      isInput: false,
    },
    {
      label: "目標（その他）",
      prop: "goalOther",
      width: 214,
      isInput: true,
    },
    {
      label: "実績（その他）",
      prop: "actualOther",
      width: 224,
      isInput: false,
    },
    {
      label: "達成率(%)",
      prop: "otherRate",
      width: 158,
      isInput: false,
    },
    {
      label: "目標（合計）",
      prop: "goalTotal",
      width: 214,
      isInput: false,
    },
    {
      label: "実績（合計）",
      prop: "actualTotal",
      width: 224,
      isInput: false,
    },
    {
      label: "達成率(%)",
      prop: "totalRate",
      width: 158,
      isInput: false,
    }
  ]
};

export const formatData = arr => {
  let returnArr = [];
  let week = [ "日", "月", "火", "水", "木", "金", "土" ];
  let lastItem = {
    date: "期間合計",
    goalTicket: 0,
    actualTicket: 0,
    ticketRate: "-",
    goalConcession: 0,
    actualConcession: 0,
    concessionRate: "-",
    goalCommercial: 0,
    actualCommercial: 0,
    commercialRate: "-",
    goalOther: 0,
    actualOther: 0,
    otherRate: "-",
    goalTotal: 0,
    actualTotal: 0,
    totalRate: "-",
  };

  arr.forEach(item => {
    let obj = {
      date: item.date + "(" + week[moment(item.date).day()] + ")",
      goalTicket: "",
      actualTicket: "¥" + item.actualMoneyTicket.toLocaleString(),
      ticketRate: "-",

      goalConcession: "",
      actualConcession: "¥" + item.actualMoneyConcession.toLocaleString(),
      concessionRate: "-",

      goalCommercial: "",
      actualCommercial: "¥" + item.actualMoneyCommercial.toLocaleString(),
      commercialRate: "-",

      goalOther: "",
      actualOther: "¥" + item.actualMoneyOther.toLocaleString(),
      otherRate: "-",

      goalTotal: item.goalMoneyTicket + item.goalMoneyConcession + item.goalMoneyCommercial + item.goalMoneyOther,
      actualTotal: item.actualMoneyTicket + item.actualMoneyConcession + item.actualMoneyCommercial + item.actualMoneyOther,
      totalRate: "-",
    };

    if (item.goalMoneyTicket > 0) {
      obj.goalTicket = "¥" + item.goalMoneyTicket.toLocaleString();
      obj.ticketRate = (parseInt(item.actualMoneyTicket * 10000 / item.goalMoneyTicket) / 100) + "%";
    }

    if (item.goalMoneyConcession > 0) {
      obj.goalConcession = "¥" + item.goalMoneyConcession.toLocaleString();
      obj.concessionRate = (parseInt(item.actualMoneyConcession * 10000 / item.goalMoneyConcession) / 100) + "%";
    }

    if (item.goalMoneyCommercial > 0) {
      obj.goalCommercial = "¥" + item.goalMoneyCommercial.toLocaleString();
      obj.commercialRate = (parseInt(item.actualMoneyCommercial * 10000 / item.goalMoneyCommercial) / 100) + "%";
    }

    if (item.goalMoneyOther > 0) {
      obj.goalOther = "¥" + item.goalMoneyOther.toLocaleString();
      obj.otherRate = (parseInt(item.actualMoneyOther * 10000 / item.goalMoneyOther) / 100) + "%";
    }

    lastItem.goalTicket += item.goalMoneyTicket;
    lastItem.actualTicket += item.actualMoneyTicket;
    lastItem.goalConcession += item.goalMoneyConcession;
    lastItem.actualConcession += item.actualMoneyConcession;
    lastItem.goalCommercial += item.goalMoneyCommercial;
    lastItem.actualCommercial += item.actualMoneyCommercial;
    lastItem.goalOther += item.goalMoneyOther;
    lastItem.actualOther += item.actualMoneyOther;
    lastItem.goalTotal += obj.goalTotal;
    lastItem.actualTotal += obj.actualTotal;

    if (obj.goalTotal > 0) {
      obj.totalRate = (parseInt(obj.actualTotal * 10000 / obj.goalTotal) / 100) + "%";
      obj.goalTotal = "¥" + obj.goalTotal.toLocaleString();
    } else {
      obj.goalTotal = "-";
    }

    if (obj.actualTotal > 0) {
      obj.actualTotal = "¥" + obj.actualTotal.toLocaleString();
    } else {
      obj.actualTotal = "-";
    }

    returnArr.push(obj);
  });

  if (lastItem.goalTicket > 0) {
    lastItem.ticketRate = (parseInt(lastItem.actualTicket * 10000 / lastItem.goalTicket) / 100) + "%";
    lastItem.goalTicket = "¥" + lastItem.goalTicket.toLocaleString();
  } else {
    lastItem.goalTicket = "-";
  }

  if (lastItem.goalConcession > 0) {
    lastItem.concessionRate = (parseInt(lastItem.actualConcession * 10000 / lastItem.goalConcession) / 100) + "%";
    lastItem.goalConcession = "¥" + lastItem.goalConcession.toLocaleString();
  } else {
    lastItem.goalConcession = "-";
  }

  if (lastItem.goalCommercial > 0) {
    lastItem.commercialRate = (parseInt(lastItem.actualCommercial * 10000 / lastItem.goalCommercial) / 100) + "%";
    lastItem.goalCommercial = "¥" + lastItem.goalCommercial.toLocaleString();
  } else {
    lastItem.goalCommercial = "-";
  }

  if (lastItem.goalOther > 0) {
    lastItem.otherRate = (parseInt(lastItem.actualOther * 10000 / lastItem.goalOther) / 100) + "%";
    lastItem.goalOther = "¥" + lastItem.goalOther.toLocaleString();
  } else {
    lastItem.goalOther = "-";
  }

  if (lastItem.goalTotal > 0) {
    lastItem.totalRate = (parseInt(lastItem.actualTotal * 10000 / lastItem.goalTotal) / 100) + "%";
    lastItem.goalTotal = "¥" + lastItem.goalTotal.toLocaleString();
  } else {
    lastItem.goalTotal = "-";
  }

  lastItem.actualTicket = "¥" + lastItem.actualTicket.toLocaleString();
  lastItem.actualConcession = "¥" + lastItem.actualConcession.toLocaleString();
  lastItem.actualCommercial = "¥" + lastItem.actualCommercial.toLocaleString();
  lastItem.actualOther = "¥" + lastItem.actualOther.toLocaleString();
  lastItem.actualTotal = "¥" + lastItem.actualTotal.toLocaleString();

  returnArr.push(lastItem);

  return returnArr;
};

export const checkData = (originalData, rateData) => {
  let targetData = [];
  let keyNames = [ "goalMoneyCommercial", "goalMoneyConcession", "goalMoneyOther", "goalMoneyTicket" ];

  rateData.map((obj, index) => {
    let isTarget = false;

    for (let i = 0; i < keyNames.length; i++) {
      if (obj[keyNames[i]] != originalData[index][keyNames[i]]) {
        isTarget = true;
        break;
      }
    }

    if (isTarget) {
      targetData.push({ ...obj });
    }
  });

  return targetData
};
